import React from 'react';
import PropTypes from 'prop-types';

// material ui
import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import CheckIcon from '@material-ui/icons/Check';
import EditIcon from '@material-ui/icons/Edit';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import NoteOutlinedIcon from '@material-ui/icons/NoteOutlined';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import DeleteIcon from '@material-ui/icons/Delete'

import AppActions from '../../../actions/app-actions';
import ArtifactPayload from './artifactPayload';

import {getUserRoleFromJWT, isEmpty, preformatWithRequestID, showError} from '../../../helpers';
import ViewPdfFile from '../../common/dialogs/viewPdfFile';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

export default class SelectedArtifact extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      descEdit: false,
      currentUserRole: getUserRoleFromJWT(),
      description: this.props.artifact.description || '-',
      gettingUrl: false,
      uploadFile: {},
      openPdf: {url: {}, open: false},
      remove: false,
      artifact: null
    };
  }

  componentDidUpdate(prevProps) {
    const self = this;
    if (prevProps.artifact.id !== self.props.artifact.id || (!self.props.artifact.url && !self.state.gettingUrl)) {
      self.setState({ gettingUrl: true }, () => AppActions.getArtifactUrl(self.props.artifact.id).then(() => self.setState({ gettingUrl: false })));
    }
    if (!self.state.descEdit && self.props.artifact.description && self.state.description !== self.props.artifact.description) {
      self.setState({ description: self.props.artifact.description || '-' });
    }
  }

  _descEdit(description) {
    this.setState({ description });
  }

  _onToggleEditing(event) {
    event.stopPropagation();
    if (event.keyCode === 13 || !event.keyCode) {
      if (this.state.descEdit) {
        // save change
        this.props.editArtifact(this.props.artifact.id, this.state.description);
      }
      this.setState({ descEdit: !this.state.descEdit });
    }
  }

  _toggleArtifactContentVisibility() {
    this.setState({ showPayloads: !this.state.showPayloads });
  }

  _removeDialog(artifact) {
    if (artifact)
      this.setState({ remove: true, artifact });
    else
      this.setState({ remove: false, artifact: null });
  }

  _removeArtifact(artifact) {
    return AppActions.removeArtifact(artifact.id)
      .then(() => AppActions.setSnackbar('Artifact was removed', 5000, ''))
      .catch(err => {
        var errMsg = err.res.body.error || '';
        AppActions.setSnackbar(preformatWithRequestID(err.res, `Error removing artifact: ${errMsg}`), null, 'Copy to clipboard');
      })
      .finally(() => this._removeDialog(null));
  }

  render() {
    const self = this;

    const { artifact, onExpansion } = self.props;

    const styles = {
      editButton: {
        color: 'rgba(0, 0, 0, 0.54)',
        marginBottom: '10px'
      },
      listStyle: {
        fontSize: '12px',
        paddingBottom: '10px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      listItemStyle: {
        color: '#404041',
        fontSize: '13px'
      }
    };

    const onFileUpload = (event) => {
      this.setState({ uploadFile: event.target.files[0] });
    }

    const onClickReleaseUpload = () => {
      var formData = new FormData();

      formData.append('name', this.state.uploadFile.name,);
      formData.append('size', this.state.uploadFile.size);
      formData.append('description', this.state.description);
      formData.append('release-note', this.state.uploadFile);

      AppActions.editArtifact(this.props.artifact.id, formData)
        .then(() => {
          AppActions.setSnackbar('Release note uploaded successfully!');
          this.props.refreshArtifacts();
        })
        .catch((err) => {
          showError(err, 'Problem uploading release note!')
        });
    }

    const onClickDownloadReleaseNote = () => {
      if (this.props.artifact.release_note_id) {
        AppActions.downloadArtifactReleaseNote(this.props.artifact.release_note_id)
          .then((res) => {
            var link = document.createElement('a');
            if(res.body){
              link.href = window.URL.createObjectURL(res.body);
              link.download = this.props.artifact.release_note_name || 'release_note.pdf';
              document.body.appendChild(link);
              link.click();
            }
          })
          .catch((err) => {
            showError(err, 'Problem downloading release note!');
          });
      }
    }

    const getReleaseNoteUrl = () => {
      AppActions.downloadArtifactReleaseNote(this.props.artifact.release_note_id)
        .then((res) => {
          if (res.body) {
            const file = new Blob([res.body], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(file);
            this.setState({ openPdf: { url, open: true } });
          }
        })
        .catch((err) => {
          showError(err, 'Problem downloading release note!');
        });
    }
    const onClickDeleteReleaseNote = () => {
      if (this.props.artifact.release_note_id) {
        AppActions.deleteArtifactReleaseNote(this.props.artifact.release_note_id)
          .then(() => {
            AppActions.setSnackbar('Release note deleted successfully!');
            this.props.refreshArtifacts();
            if (!isEmpty(this.state.uploadFile)) {
              this.setState({uploadFile: {}});
            }
          })
          .catch((err) => {
            showError(err, 'Problem deleting release note!');
          });
      }
    }

    const onPdfClose = () => {
      this.setState({ openPdf: { open: false, url: {} } });
    }

    return (
      <div className={artifact.name == null ? 'muted' : null}>
        <div style={styles.listStyle}>
          <FormControl className="list-item list-item-large">
            <InputLabel htmlFor="artifact-description">Description</InputLabel>
            <Input
              id="artifact-description"
              type="text"
              style={styles.listItemStyle}
              disabled={!self.state.descEdit || this.state.currentUserRole !== 'admin'}
              value={self.state.description}
              onKeyDown={e => this._onToggleEditing(e)}
              onChange={e => this._descEdit(e.target.value)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton style={styles.editButton} onClick={e => self._onToggleEditing(e)}>
                    {self.state.descEdit ? <CheckIcon /> : <EditIcon />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
          <FormControl className="list-item">
            <InputLabel htmlFor="artifact-signed">Signed</InputLabel>
            <Input
              id="artifact-signed"
              disabled={true}
              startAdornment={
                <InputAdornment position="start">
                  {artifact.signed ? <CheckCircleOutlineIcon className="green" /> : <CancelOutlinedIcon className="red" />}
                </InputAdornment>
              }
              style={styles.listItemStyle}
              type="text"
            />
          </FormControl>
        </div>

        <ExpansionPanel
          square
          expanded={self.state.showPayloads}
          onChange={() => self._toggleArtifactContentVisibility()}
          CollapseProps={{ onEntered: () => onExpansion(), onExited: () => onExpansion() }}
          style={{ background: '#e9e9e9', borderTop: 'none', padding: '0 15px', margin: '30px 0' }}
        >
          <ExpansionPanelSummary style={{ padding: 0 }}>
            <p>Artifact contents</p>
            <div style={{ marginLeft: 'auto' }}>{self.state.showPayloads ? <RemoveIcon /> : <AddIcon />}</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ padding: 0 }}>
            {artifact.updates ? (
              artifact.updates.map((update, index) => <ArtifactPayload index={index} payload={update} key={`artifact-update-${index}`} />)
            ) : (
              <div />
            )}
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <div style={{ marginBottom: '10px' }}>
          {(this.props.artifact.release_note_id) ? (
            <div>
              <InputLabel htmlFor='release_note_link' disabled shrink>Release Note</InputLabel>
              <a id='release_note_link' onClick={getReleaseNoteUrl}>{this.props.artifact.release_note_name}</a>
              <IconButton aria-label="delete" onClick={onClickDeleteReleaseNote}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </div>) :
            (
              <div>
                <InputLabel htmlFor='release_note' disabled shrink>Release Note</InputLabel>
                <Input id='release_note' type='file' inputProps={{ accept: '.pdf' }} onChange={onFileUpload} />
                <Button onClick={onClickReleaseUpload} disabled={isEmpty(this.state.uploadFile)}><CloudUploadOutlinedIcon /></Button>
              </div>
            )}
        </div>

        <Button href={artifact.url} target="_blank" disabled={!artifact.url}>
          <ExitToAppIcon style={{ transform: 'rotateZ(90deg)' }} className="buttonLabelIcon" />
          Download Artifact
        </Button>

        <div className="margin-left inline">
          <Button onClick={() => this._removeDialog(artifact)} disabled={this.state.currentUserRole !== 'admin'}>
            <CancelIcon className="red auth buttonLabelIcon" />
            Remove this Artifact?
          </Button>
        </div>

        <Button onClick={onClickDownloadReleaseNote} disabled={!this.props.artifact.release_note_id}>
          <NoteOutlinedIcon className="buttonLabelIcon" />
            Download Realease Note
        </Button>

        <ViewPdfFile open={this.state.openPdf.open} pdf={this.state.openPdf.url} fileName={this.props.artifact.release_note_name}
          onClose={onPdfClose} />

        <Dialog open={this.state.remove}>
          <DialogTitle>Remove this artifact?</DialogTitle>
          <DialogContent>
            Are you sure you want to remove <i>{(artifact || {}).name}</i>?
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this._removeDialog(null)}>Cancel</Button>
            <div style={{ flexGrow: 1 }} />
            <Button variant="contained" color="secondary" onClick={() => self._removeArtifact(artifact)}>
              Remove artifact
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
